import { Pipe, PipeTransform } from '@angular/core';
import { PreBookingInformation } from '../dialogs/add-prebooking-dialog/add-prebooking-dialog.component';

@Pipe({
  name: 'prebookingName',
})
export class PrebookingNamePipe implements PipeTransform {
  transform(prebookings: PreBookingInformation[] | null | undefined, ...args: any[]): string | null | undefined {
    return prebookings && prebookings.length > 0 ? prebookings.map((x) => x.shipmentReference).join(';') : '';
  }
}
